import loadCarouselProducts from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import { getProductsForProductInfoList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import Typography from "@insite/mobius/Typography";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import Card from "@midland-industries/Components/Card";
import Group from "@midland-industries/Components/Group";
import Stack from "@midland-industries/Components/Stack";
import { CustomNewProductsState } from "@midland-industries/Store/Data/NewProducts/NewProductsReducer";
import { colors } from "@midland-industries/Styles/colors";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled from "styled-components";

const mapStateToProps = (state: CustomNewProductsState) => {
    return {
        products: getProductsForProductInfoList(state, "bestSellingItemsCard"),
    };
};

const mapDispatchToProps = {
    loadCarouselProducts,
};

type BestSellingItemsCardProps = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const ItemDetails = styled.div`
    @keyframes fade-in {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }
    animation: fade-in 0.35s ease-in-out;
    padding: 10px;
    border-radius: 20px;
    border: 1px solid ${colors.border};
    background-color: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(3px);
    text-align: center;
    position: absolute;
    max-width: 175px;
`;

const Item: React.FC<ProductModel> = ({ smallImagePath, productTitle, canonicalUrl }) => {
    const history = useHistory();
    const [showDetail, setShowDetail] = useState(false);

    const handleClick = () => {
        history.push(canonicalUrl);
    };

    return (
        <Stack
            justify="center"
            align="center"
            onMouseEnter={() => setShowDetail(true)}
            onMouseLeave={() => setShowDetail(false)}
            onClick={handleClick}
            style={{
                width: 137,
                height: 127,
                backgroundImage: `url(${smallImagePath})`,
                backgroundSize: "cover",
                cursor: "pointer",
            }}
        >
            {showDetail ? (
                <ItemDetails onClick={handleClick}>
                    <Typography color={colors.textLink} lineHeight="18px" weight={700}>
                        {productTitle || ""}
                    </Typography>
                </ItemDetails>
            ) : (
                <></>
            )}
        </Stack>
    );
};

const BestSellingItemsCard: React.FC<BestSellingItemsCardProps> = ({ products, loadCarouselProducts }) => {
    const [loading, setLoading] = useState(!products?.length);

    useEffect(() => {
        if (!products?.length) {
            loadCarouselProducts({
                carouselId: "bestSellingItemsCard",
                carouselType: "topSellers",
                numberOfProductsToDisplay: 4,
                displayProductsFrom: "allCategories",
                selectedCategoryIds: [],
                isProductListPage: false,
                isBrandDetailsPage: false,
                relatedProductType: "",
                seedWithManuallyAssigned: "",
                isProductDetailsPage: false,
            });
        } else {
            setLoading(false);
        }
    }, [products]);

    return (
        <Card title="Best-selling items" width={360} height={321}>
            {loading ? (
                <Stack align="center" justify="center" style={{ height: "100%" }}>
                    <LoadingSpinner color={colors.border} />
                </Stack>
            ) : (
                <Group justify="space-around" wrap style={{ height: "100%" }}>
                    {products?.map(product => (
                        <Item key={product.id} {...product} />
                    ))}
                </Group>
            )}
        </Card>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(BestSellingItemsCard);
